export const MARKER = '\u2063';
export const ZERO_WIDTH_DIGITS = ['\u200B', '\u200C', '\u200D'];
export const TOKEN_REGEX = /@\[([^\]]+)\]\(user:(\d+)\)/g;

export function buildPlaceholderRegex() {
  // Maintained for backward compatibility; no longer used.
  return null;
}

export function encodeSequence(number) {
  if (number === 0) {
    return ZERO_WIDTH_DIGITS[0];
  }

  let encoded = '';
  let quotient = number;

  while (quotient > 0) {
    const remainder = quotient % ZERO_WIDTH_DIGITS.length;
    encoded = `${ZERO_WIDTH_DIGITS[remainder]}${encoded}`;
    quotient = Math.floor(quotient / ZERO_WIDTH_DIGITS.length);
  }

  return encoded;
}

export function convertExistingTokens(text, mentionMap, sequenceRef) {
  if (!text || !text.includes('@[')) {
    return text || '';
  }

  return text.replace(TOKEN_REGEX, (_, name, id) => {
    const encoded = encodeSequence(sequenceRef.value++);
    mentionMap.set(encoded, { name, userId: Number.parseInt(id, 10) });
    return `${name}${MARKER}${encoded}${MARKER}`;
  });
}

export function replacePlaceholdersWithTokens(text, mentionMap) {
  if (!text) {
    return '';
  }

  let result = text;

  mentionMap.forEach((mention, encoded) => {
    const placeholder = `${mention.name}${MARKER}${encoded}${MARKER}`;
    const token = `@[${mention.name}](user:${mention.userId})`;

    if (result.includes(placeholder)) {
      result = result.split(placeholder).join(token);
    }
  });

  return result.split(MARKER).join('');
}

export function escapeHtml(value) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
